import type { DocumentStatus, SpaceId } from '@rock/types';

/** The catalog list pages all filter on the same two axes. */
export type StatusFilter = DocumentStatus | 'all';
export type SpaceFilter = SpaceId | 'all';

export const STATUS_FILTER_LABELS: Record<StatusFilter, string> = {
    approved: 'Approved',
    draft: 'Draft',
    revisit: 'Revisit',
    retired: 'Retired',
    all: 'All',
};
